import axios from "axios";
import { api } from "../settings";
import md5 from "js-md5";

let apiUrl = process.env.VUE_APP_API + process.env.VUE_APP_API_UM;
class UM {
  static getUserInfo() {
    let token = JSON.parse(Cookies.get("user"))
      ? JSON.parse(Cookies.get("user")).access_token
      : "";
    return axios.get(`${apiUrl}/getUserInfo`, {
      headers: {
        authorization: `Bearer ${token}`
      }
    });
  }

  static getMaskedUserInfo() {
    let token = JSON.parse(Cookies.get("user"))
      ? JSON.parse(Cookies.get("user")).access_token
      : "";
    return axios.get(`${apiUrl}/getMaskedUserInfo`, {
      headers: {
        authorization: `Bearer ${token}`
      }
    });
  }

  static login(countryCode, mobile, password) {
    return axios.post(
      `${apiUrl}/login`,
      {
        mobile: mobile,
        countryCode: countryCode,
        password: md5(password)
      },
      {
        headers: { "content-type": "application/json" }
      }
    );
  }

  // 驗證 token 是否有效
  static verifyToken(token) {
    return axios.post(`${apiUrl}/token`, { token: token });
  }

  // 驗證欲註冊之手機號碼是否已註冊
  static verify(countryCode, mobile) {
    return axios.post(`${apiUrl}/verify`, {
      countryCode: countryCode,
      mobile: mobile
    });
  }

  // OTP驗證欲註冊之手機號碼
  static otp(countryCode, mobile) {
    return axios.post(`${apiUrl}/otp`, {
      countryCode: countryCode,
      mobile: mobile
    });
  }

  // 驗證欲註冊之手機號碼
  static validateOTP(countryCode, mobile, certificate) {
    return axios.post(`${apiUrl}/validateOTP`, {
      countryCode: countryCode,
      mobile: mobile,
      certificate: certificate
    });
  }

  // 使用者註冊
  static register(countryCode, mobile, password, email) {
    return axios.post(`${apiUrl}/register`, {
      countryCode: countryCode,
      mobile: mobile,
      password: md5(password),
      email: email
    });
  }

  // 更新使用者資訊
  static updateUserInfo(data) {
    let token = JSON.parse(Cookies.get("user"))
      ? JSON.parse(Cookies.get("user")).access_token
      : "";
    return axios.post(`${apiUrl}/update`, data, {
      headers: {
        authorization: `Bearer ${token}`,
        "content-type": "application/json"
      }
    });
  }

  // 建立或更新身障資訊
  static createDisability(params) {
    let token = JSON.parse(Cookies.get("user"))
      ? JSON.parse(Cookies.get("user")).access_token
      : "";
    return axios.post(`${apiUrl}/createDisability`, params, {
      headers: {
        authorization: `Bearer ${token}`,
        "content-type": "application/json"
      }
    });
  }

  static sendEmailVerify() {
    let token = JSON.parse(Cookies.get("user"))
      ? JSON.parse(Cookies.get("user")).access_token
      : "";
    return axios.post(
      `${apiUrl}/emailVerify`,
      {},
      {
        headers: {
          authorization: `Bearer ${token}`,
          "content-type": "application/json"
        }
      }
    );
  }

  // 驗證電郵地址郵件內的key
  static verifyEmail(key) {
    return axios.get(`${apiUrl}/email?key=${key}`);
  }

  // 發送忘記密碼信件
  static sendForgetPassword(countryCode, mobile, email) {
    return axios.post(`${apiUrl}/forgetPassword`, {
      countryCode,
      mobile: mobile,
      email: email
    });
  }

  // 驗證忘記密碼郵件內的key
  static verifyPassword(key) {
    return axios.get(`${apiUrl}/password?key=${key}`);
  }

  // 更新密碼
  static resetPassword(key, password) {
    return axios.post(`${apiUrl}/password`, {
      key: key,
      newPassword: md5(password)
    });
  }

  static refreshToken() {
    let token = JSON.parse(Cookies.get("user"))
      ? JSON.parse(Cookies.get("user")).refresh_token
      : "";
    return axios.post(
      `${apiUrl}/refreshToken`,
      {},
      {
        headers: {
          authorization: `Bearer ${token}`
        }
      }
    );
  }
}

export default UM;
